var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "long"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "background",
    y: 13,
    width: 40,
    height: 16,
    rx: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8199 19.304C39.042 15.7003 35.8363 13 32 13H8C3.58172 13 0 16.5817 0 21C0 22.8341 0.617233 24.5241 1.65532 25.8735L3.99786 25.4703C2.77161 24.3717 2 22.776 2 21C2 17.6863 4.68629 15 8 15H32C34.8473 15 37.2313 16.9833 37.8461 19.6438L39.8199 19.304Z",
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.65532 25.8735C3.11789 27.7748 5.41586 29 8 29H32C36.4183 29 40 25.4183 40 21C40 20.4181 39.9379 19.8506 39.8199 19.304L37.8461 19.6438C37.9468 20.0796 38 20.5336 38 21C38 24.3137 35.3137 27 32 27H8C6.46226 27 5.05963 26.4215 3.99786 25.4703L1.65532 25.8735Z",
    fill: "black",
    fillOpacity: 0.25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLong);
export default __webpack_public_path__ + "static/media/long.6918eae8fd90eeb03b65bbfbd83271ad.svg";
export { ForwardRef as ReactComponent };